import { TempPassword } from "@features/auth/auth";
import { createFileRoute } from "@tanstack/react-router";

type TempPasswordType = {
	strength: string;
};

export const Route = createFileRoute("/login/_guest/temp")({
	component: RouteComponent,
	validateSearch: (search: Record<string, string>): TempPasswordType => {
		return {
			strength: search.strength,
		};
	},
});

function RouteComponent() {
	return <TempPassword />;
}
